<script lang="ts" setup>
	import dayjs from 'dayjs'

	const props = defineProps<{
		metaDetails: PolicyResponse | null
		premium?: string
	}>()
	const { currencyToNaira } = useCurrency()
	const { formatDate } = useCustomDate()
	const { gadgetMeta, expiryDate, purchaseDate, policyNumber, policyCertificate } = usePolicyInfo(() => ({
		policyInfo: props.metaDetails
	}))
	const policyDetails = computed(() => ({
		'Policy number': policyNumber.value,
		'Purchase Date': formatDate(purchaseDate.value, 'DD MMM, YYYY'),
		'Expiry Date': formatDate(expiryDate.value, 'DD MMM, YYYY'),
		'Gadget Type': gadgetMeta.value.type,
		'Gadget Brand': gadgetMeta.value.brand,
		'Gadget Value': currencyToNaira(gadgetMeta.value.value),
		'Serial Number': gadgetMeta.value.serial_number,
		'Gadget Model': gadgetMeta.value.model,
		'Gadget Colour': gadgetMeta.value.colour,
		'Gadget Rate': gadgetMeta.value.rate,
		'Gadget Premium': currencyToNaira(props.premium || 0),
		'Policy Certificate': policyCertificate.value
	}))
</script>

<template>
	<my-cover-policy-card :details="policyDetails">
		<template #value="{ record, dataIndex }">
			<template v-if="dataIndex === 'policy_certificate'">
				<div
					class="flex min-h-[44px] w-full items-center gap-x-3 rounded-md border border-gray-100 bg-gray-50 p-3"
				>
					<lazy-tools-icon
						dir="documents"
						:icon="(!record && 'document-text') || 'pdf'"
						:path-class="(!record && 'fill-gray-300') || ''"
					/>

					<nuxt-link v-show="Boolean(record)" :to="String(record)" target="_blank"> certs.pdf </nuxt-link>

					<span v-show="!record"> ---- </span>
				</div>
			</template>
		</template>
	</my-cover-policy-card>
</template>
